// This is a mapping of the icon names to the actual icon components used in jti-next
export const dropdownMapper = {
    Account: "account",
    "Check + round": "checkMarkWithRoundBorder",
    "Check Plus Circle": "checkPlusCircle",
    "Credit card + lock": "cardWithLock",
    Edit: "edit",
    "Falling plus": "falling",
    "Ingredients - Fibers": "ingredientFibers",
    "Ingredients - Flavoring": "ingredientFlavoring",
    "Ingredients - Gumbase": "ingredientGumbase",
    "Ingredients - Nicotine": "ingredientNicotine",
    "Lock Outline Close": "lockOutlineClose",
    "Mouth tingle": "mouthTingle",
    "No smoke smell": "noSmokeSmell",
    Package: "package",
    "Package + arrow": "packageWithArrow",
    "Package + checkmark": "packageWithCheckMark",
    "Package + clock": "packageWithClock",
    "Package return": "packageReturn",
    "Package shopping": "packageShopping",
    "Pin - time & place": "pinTimePlace",
    "Pouch - dispose": "pouchDispose",
    "Profile - family": "profileFamily",
    Timer: "timer",
    "Tobacco leaf": "tobaccoLeaf",
};
//# sourceMappingURL=dropdownMapper.js.map